import {io, Socket} from "socket.io-client";
import {scheduleApi} from "../api/schedule-api";
import {
    removeScheduleByIdAction,
    setSchedulePageAllAction,
    setSchedulePageAllByDtoAction,
} from "../app/reducers/schedule-slice";
import {store} from "../app/store";
import {
    CompleteScheduleSocketIoMessage,
    CreateScheduleSocketIoMessage,
    SocketIoType,
    StartScheduleSocketIoMessage,
    UpdateScheduleSocketIoMessage,
} from "../types/alert/alert-message";
import {SOCKET_CONNECT_TIMEOUT} from "../types/constant";
import {todayYYYYMMDD} from "../utils/date/date-format";
import {queryClient} from "../index";
import {DeliveryQueryKey} from "../query/delivery-query";

class SocketIO {
    private _client?: Socket;

    getTodaySchedule = async () => {
        try {
            const response = await scheduleApi.searchAll({
                specificDate: todayYYYYMMDD,
            });
            const schedulePageAllDto = response.data;
            store.dispatch(
                setSchedulePageAllAction({
                    schedulePageAllDto,
                })
            );
        } catch (error) {
            console.log(error);
        }
    };

    connect(url: string, token: string) {
        this.disconnect();
        const client = io(url, {
            transports: ["websocket"],
            auth: {
                token,
            },
            path: "/socket",
            reconnectionDelay: SOCKET_CONNECT_TIMEOUT,
            reconnectionDelayMax: SOCKET_CONNECT_TIMEOUT,
        });
        this._client = client;
        client.on(SocketIoType.ScheduleCreate, (data) => {
            this._handleCreateSchedule(data);
        });
        client.on(SocketIoType.ScheduleMatch, (data) => {
            this._handleCreateSchedule(data);
        });
        client.on(SocketIoType.ScheduleUpdate, (data) => {
            this._handleUpdateSchedule(data);
        });
        client.on(SocketIoType.ScheduleComplete, (data) => {
            this._handleCompleteSchedule(data);
        });
        client.on(SocketIoType.ScheduleDelete, (data) => {
            this._handleDeleteSchedule(data);
        });
        client.on(SocketIoType.ScheduleRefresh, (data) => {
            this._handleRefreshSchedule(data);
        });
        client.on("connect", this.getTodaySchedule);
        // client.on("reconnect", this.getTodaySchedule);
    }

    disconnect() {
        if (this._client) {
            this._client.disconnect();
        }
    }

    is_connected() {
        if (!this._client) {
            return false;
        }
        return this._client.connected;
    }

    close() {
        if (this._client && this._client.connected) {
            this._client.close();
        }
    }

    _updateSchedule = async (scheduleId: string) => {
        try {
            const response = await scheduleApi.getById(scheduleId);
            const scheduleDto = response.data;
            if (scheduleDto.dateToWork !== todayYYYYMMDD) {
                return;
            }
            store.dispatch(setSchedulePageAllByDtoAction({scheduleDto}));
        } catch (error) {
            console.log(error);
        }
    };

    _updateDeliveryPageAll = async () => {
        await queryClient.invalidateQueries(DeliveryQueryKey.PageAll);
    };

    _updateScheduleAndDelivery = async (scheduleId: string) => {
        this._updateSchedule(scheduleId);
        this._updateDeliveryPageAll();
    };

    _handleCreateSchedule = async (obj: any) => {
        const {scheduleId} = obj as CreateScheduleSocketIoMessage;
        this._updateScheduleAndDelivery(scheduleId);
    };

    _handleStartSchedule = (obj: any) => {
        const {scheduleId} = obj as StartScheduleSocketIoMessage;
        this._updateSchedule(scheduleId);
    };
    _handleCompleteSchedule = (obj: any) => {
        const {scheduleId} = obj as CompleteScheduleSocketIoMessage;
        this._updateSchedule(scheduleId);
    };

    _handleRefreshSchedule = (obj: any) => {
        const {scheduleId} = obj as UpdateScheduleSocketIoMessage;
        this._updateSchedule(scheduleId);
    };

    _handleUpdateSchedule = (obj: any) => {
        const {scheduleId} = obj as UpdateScheduleSocketIoMessage;
        this._updateScheduleAndDelivery(scheduleId);
    };

    _handleDeleteSchedule = (obj: any) => {
        const {scheduleId} = obj as UpdateScheduleSocketIoMessage;
        store.dispatch(removeScheduleByIdAction(
            {scheduleId: scheduleId}
        ));
    };
}

export const socketIO = new SocketIO();
